/**
 * Align left-filter counts with color-split product cards on collection pages.
 * Shopify counts products; the grid shows one card per Base Color.
 */
(function () {
  const CATALOG_ID = 'kostch-facet-catalog';
  const STORAGE_KEY = 'kostchFacetCatalog';

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function filterKind(label) {
    const l = norm(label);
    if (!l) return null;
    if (l === 'size' || l.startsWith('size')) return 'size';
    if (l.includes('base color') || l === 'color' || l === 'colour' || l === 'finish') return 'base';
    if (l.includes('accent')) return 'accent';
    if (l.includes('fuel')) return 'fuel';
    return null;
  }

  function readCatalogFrom(root) {
    const el = (root || document).getElementById(CATALOG_ID);
    if (!el) return [];
    try {
      const data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function mergeCatalog(incoming) {
    const map = new Map();
    (window.KostchFacetCatalog || []).forEach((p) => map.set(p.id, p));
    (incoming || []).forEach((p) => {
      if (p && p.id != null) map.set(p.id, p);
    });
    window.KostchFacetCatalog = Array.from(map.values());
    try {
      sessionStorage.setItem(
        STORAGE_KEY + ':' + (window.KostchFacetCollectionId || ''),
        JSON.stringify(window.KostchFacetCatalog)
      );
    } catch (e) {}
    return window.KostchFacetCatalog;
  }

  function loadStoredCatalog(collectionId) {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY + ':' + collectionId);
      if (!raw) return [];
      const data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function activeFilters(form) {
    const selected = { size: [], base: [], accent: [], fuel: [] };
    if (!form) return selected;

    form.querySelectorAll('input[name^="filter."]:checked').forEach((input) => {
      if (input.name && input.name.indexOf('filter.v.price') === 0) return;
      if (input.name === 'filter.v.availability') return;

      const group = input.closest('[data-kostch-filter]');
      const label = group ? group.getAttribute('data-kostch-filter') : '';
      const kind = filterKind(label);
      if (!kind || !selected[kind]) return;
      selected[kind].push(norm(input.value));
    });

    return selected;
  }

  function productMatches(product, selected, ignoreKind) {
    const checks = [
      ['size', product.size, false],
      ['fuel', product.fuel, false],
      ['base', product.baseColors || [], true],
      ['accent', product.accentColors || [], true]
    ];

    for (let i = 0; i < checks.length; i++) {
      const kind = checks[i][0];
      const value = checks[i][1];
      const isList = checks[i][2];
      if (kind === ignoreKind) continue;
      const wanted = selected[kind] || [];
      if (!wanted.length) continue;
      if (isList) {
        const have = (value || []).map(norm).filter(Boolean);
        if (!wanted.some((w) => have.indexOf(w) !== -1)) return false;
      } else if (wanted.indexOf(norm(value)) === -1) {
        return false;
      }
    }
    return true;
  }

  function accentFactor(product, selected) {
    const accents = (product.accentColors || []).filter(Boolean);
    const accentWanted = selected.accent || [];
    if (!accents.length) return 1;
    if (!accentWanted.length) return accents.length;
    const matched = accentWanted.filter((w) => accents.map(norm).indexOf(w) !== -1).length;
    return matched || 1;
  }

  function countForValue(catalog, selected, kind, value) {
    const v = norm(value);
    let total = 0;

    catalog.forEach((product) => {
      if (!productMatches(product, selected, kind)) return;

      if (kind === 'size') {
        if (norm(product.size) !== v) return;
        total += (product.cardCount || 1) * accentFactor(product, selected);
      } else if (kind === 'fuel') {
        if (norm(product.fuel) !== v) return;
        total += (product.cardCount || 1) * accentFactor(product, selected);
      } else if (kind === 'base') {
        const have = (product.baseColors || []).map(norm);
        if (have.indexOf(v) === -1) return;
        const accents = (product.accentColors || []).filter(Boolean);
        const accentWanted = selected.accent || [];
        if (accentWanted.length) {
          total += accentWanted.filter((w) => accents.map(norm).indexOf(w) !== -1).length || 1;
        } else {
          total += accents.length || 1;
        }
      } else if (kind === 'accent') {
        const have = (product.accentColors || []).map(norm);
        if (have.indexOf(v) === -1) return;
        const baseWanted = selected.base || [];
        if (baseWanted.length) {
          const bases = (product.baseColors || []).map(norm);
          total += baseWanted.filter((w) => bases.indexOf(w) !== -1).length || 1;
        } else {
          total += product.cardCount || 1;
        }
      }
    });

    return total;
  }

  function totalCards(catalog, selected) {
    let total = 0;
    catalog.forEach((product) => {
      if (!productMatches(product, selected, null)) return;
      const accents = (product.accentColors || []).filter(Boolean);
      const accentWanted = selected.accent || [];
      let accentN = accents.length || 1;
      if (accentWanted.length) {
        accentN = accentWanted.filter((w) => accents.map(norm).indexOf(w) !== -1).length || 1;
      }
      let cards = (product.cardCount || 1) * accentN;
      const baseWanted = selected.base || [];
      if (baseWanted.length) {
        const have = (product.baseColors || []).map(norm);
        const matchedBases = baseWanted.filter((w) => have.indexOf(w) !== -1).length;
        cards = matchedBases * accentN;
      }
      total += cards;
    });
    return total;
  }

  function setLabelCount(labelEl, count) {
    if (!labelEl) return;
    const text = (labelEl.textContent || '').replace(/\s*\(\d+\)\s*$/, '').trim();
    labelEl.textContent = text + ' (' + count + ')';
  }

  function updateToolbarCount(section, count) {
    const el = section.querySelector('.collection-toolbar__products-count');
    if (!el) return;
    const current = (el.textContent || '').trim();
    if (/\d+/.test(current)) {
      el.textContent = current.replace(/\d+/, String(count));
    } else {
      el.textContent = count === 1 ? '1 PRODUCT' : count + ' PRODUCTS';
    }
  }

  function updateFacetCounts(section) {
    if (!section || section.getAttribute('data-kostch-split-by-color') !== 'true') return;

    const catalog = window.KostchFacetCatalog || [];
    if (!catalog.length) return;

    const form =
      section.querySelector('facets-form[update-on-change] form') ||
      section.querySelector('facets-form form');
    const selected = activeFilters(form);

    section.querySelectorAll('[data-kostch-filter]').forEach((group) => {
      const kind = filterKind(group.getAttribute('data-kostch-filter'));
      if (!kind) return;

      group.querySelectorAll('input[name^="filter."]').forEach((input) => {
        if (input.value === undefined || input.value === null || input.value === '') return;
        const count = countForValue(catalog, selected, kind, input.value);
        const localLabel = input.parentElement && input.parentElement.querySelector('label');
        setLabelCount(localLabel, count);
      });
    });

    updateToolbarCount(section, totalCards(catalog, selected));
  }

  async function ensureFullCatalog(section) {
    const collectionUrl = section.getAttribute('data-kostch-collection-url');
    const collectionId = section.getAttribute('data-kostch-collection-id') || '';
    const sectionId = section.getAttribute('data-section-id') || '';
    window.KostchFacetCollectionId = collectionId;

    mergeCatalog(loadStoredCatalog(collectionId));
    mergeCatalog(readCatalogFrom(section));

    if (window.KostchFacetCatalogFetched === collectionId) {
      updateFacetCounts(section);
      return;
    }

    if (!collectionUrl || !sectionId) {
      updateFacetCounts(section);
      return;
    }

    try {
      const url = new URL(collectionUrl, window.location.origin);
      Array.from(url.searchParams.keys()).forEach((key) => {
        if (key.indexOf('filter.') === 0 || key === 'page' || key === 'sort_by') {
          url.searchParams.delete(key);
        }
      });
      url.searchParams.set('section_id', sectionId);

      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      mergeCatalog(readCatalogFrom(doc));
      window.KostchFacetCatalogFetched = collectionId;
    } catch (e) {
      // keep local merge
    }

    updateFacetCounts(section);
  }

  function findSection() {
    return document.querySelector('[data-kostch-split-by-color="true"]');
  }

  function currentSortBy(section) {
    try {
      const fromUrl = new URL(window.location.href).searchParams.get('sort_by');
      if (fromUrl) return fromUrl;
    } catch (e) {}
    return (section && section.getAttribute('data-kostch-sort-by')) || '';
  }

  /**
   * Color-split cards follow product → option order. Shopify price sort only
   * orders products, so re-order visible cards by each card's variant price.
   */
  function cardSortPrice(card) {
    const raw = card.getAttribute('data-card-price');
    if (raw != null && raw !== '') {
      const n = Number(raw);
      if (!Number.isNaN(n)) return n;
    }
    const priceRoot = card.querySelector('.price-list, .price, [class*="price"]');
    const text = ((priceRoot && priceRoot.textContent) || '').replace(/,/g, '');
    const match = text.match(/(\d+(?:\.\d+)?)/);
    return match ? Math.round(parseFloat(match[1], 10) * 100) : 0;
  }

  function sortCardsByPrice(section) {
    if (!section) return;
    const sortBy = currentSortBy(section);
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return;
    if (section.getAttribute('data-kostch-split-by-color') !== 'true') return;

    const list = section.querySelector('product-list.product-list, product-list, .product-list');
    if (!list) return;
    const cards = Array.prototype.filter.call(list.children, function (el) {
      return el && el.tagName === 'PRODUCT-CARD';
    });
    if (cards.length < 2) return;

    const dir = sortBy === 'price-descending' ? -1 : 1;
    const ranked = cards.slice().sort(function (a, b) {
      const pa = cardSortPrice(a);
      const pb = cardSortPrice(b);
      if (pa !== pb) return (pa - pb) * dir;
      const aa = a.getAttribute('data-card-available') === '1' ? 0 : 1;
      const ab = b.getAttribute('data-card-available') === '1' ? 0 : 1;
      if (aa !== ab) return aa - ab;
      return 0;
    });

    let same = true;
    for (let i = 0; i < cards.length; i++) {
      if (cards[i] !== ranked[i]) {
        same = false;
        break;
      }
    }
    if (same) return;

    const marks = cards.map(function (card) {
      const mark = document.createComment('kostch-price-sort');
      card.replaceWith(mark);
      return mark;
    });
    marks.forEach(function (mark, index) {
      mark.replaceWith(ranked[index]);
    });
  }

  function refreshAfterDomSwap() {
    let tries = 0;
    const timer = setInterval(function () {
      const section = findSection();
      if (section) {
        mergeCatalog(readCatalogFrom(section));
        updateFacetCounts(section);
        sortCardsByPrice(section);
      }
      tries += 1;
      if (tries >= 25) clearInterval(timer);
    }, 40);
  }

  function boot() {
    const section = findSection();
    if (!section) return;
    ensureFullCatalog(section);
    sortCardsByPrice(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('facet:update', refreshAfterDomSwap);
  document.documentElement.addEventListener('theme:loading:end', refreshAfterDomSwap);
})();
